import { VFC } from 'react';

export const PolicyPage: VFC = () => {
  return (
    <div>
      <h1>プライバシーポリシー</h1>
      <p>
        Shitforces（以下，「本サイト」といいます。）は，本サービスにおける，ユーザーの個人情報の取扱いについて，
        以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。
      </p>

      <h2>第1条（個人情報）</h2>
      <p>
        「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，
        当該情報に含まれる氏名，生年月日，住所，電話番号，
        連絡先その他の記述等により特定の個人を識別できる情報及び容貌，指紋，声紋にかかるデータ，
        及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
      </p>
      <br />

      <h2>第2条（個人情報の利用）</h2>
      <p>当サイトでは個人情報を扱っておりません。</p>
      <br />

      <h2>第3条（利用目的の変更）</h2>
      <ol>
        <li>
          当サイトは，利用目的が変更前と関連性を有すると合理的に認められる場合に限り，個人情報の利用目的を変更するものとします。
        </li>
        <li>
          利用目的の変更を行った場合には，変更後の目的について，
          当サイト所定の方法により，ユーザーに通知し，または本ウェブサイト上に公表するものとします。
        </li>
      </ol>
      <br />

      <h2>第4条（プライバシーポリシーの変更）</h2>
      <ol>
        <li>
          本ポリシーの内容は，法令その他本ポリシーに別段の定めのある事項を除いて，ユーザーに通知することなく，
          変更することができるものとします。
        </li>
        <li>
          当サイトが別途定める場合を除いて，変更後のプライバシーポリシーは，
          本ウェブサイトに掲載したときから効力を生じるものとします。
        </li>
      </ol>
      <br />

      <h2>第5条（お問い合わせ窓口）</h2>
      <p>本ポリシーに関するお問い合わせは，下記までお願いいたします。</p>
      <p>
        Eメールアドレス：
        <a href={'mailto:oneky8080@gmail.com'}>oneky8080@gmail.com</a>
        <br />
        Twitter: <a href={'https://twitter.com/Shitforces'}>@Shitforces</a>
      </p>
    </div>
  );
};
